import React from 'react'
import Navbar from '../inc/Navbar'

import { Link } from "react-router-dom";

import ScrollToTop from "react-scroll-to-top";
import kpsdirector from "../images/director.jpeg";



function MrAmitavaGuha() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
               <div className="album py-1">
                <div className="container">
                    <h1> KRISHNAGAR PUBLIC SCHOOL </h1>
                </div>
            </div>

            <div className='cbscschoolnadia'>
                <div className='album py-1'>
                    <div className='container mt-3'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">Director <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <ScrollToTop smooth top="100" color="darkgoldenrod" />
            <br />
            <div className="album py-0">
                <div className="container">

                    <div className="card-body">
                        <div className='welcometext'>
                            <h1 className="card-title mb-3"><b>Message from the Director </b></h1>
                        </div>
                        <div className="album py-0">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-3 mt-3">
                                        <div class="card">
                                            <img src={kpsdirector} className="card-img-top" alt="kps_director" />
                                        </div>

                                    </div>
                                    <div className="col-md-9 mt-3">
                                                                       <p className="card-text justify">It gives me immense pride and heartfelt joy to welcome you to <b>Krishnagar Public School</b>, the first CBSE school of Krishnagar. At KPS, we believe that education is not merely the acquisition of knowledge, but the transformation of young minds into confident, responsible and compassionate individuals. </p>
                                            <p className="card-text mb-3 justify">Our mission is to create a dynamic learning environment where academic excellence blends seamlessly with strong moral values and life skills. We are committed to nurturing curiosity, creativity and critical thinking, ensuring that every child discovers his or her unique potential and dares to dream big.
 </p>
                                        <p className='justify mb-2'>At KPS, learning goes beyond textbooks. Through innovative teaching methodologies, modern technology and a dedicated team of passionate educators, we strive to provide holistic development — intellectually, emotionally, socially and ethically. We ensure that our students grow in a safe, supportive and inspiring atmosphere where they feel valued and empowered. </p>
                                        <p className='justify mb-2'>We consider our students as our greatest strength and our proudest achievement. With the continuous support and partnership of parents, we aim to shape future leaders who will contribute positively to society and uphold the values of integrity, respect and responsibility. </p>
                                        <p className='justify mb-2'>     I firmly believe that every child who walks through our gates carries the promise of a brighter tomorrow. Together, let us build a strong foundation today for a successful and meaningful future.   </p>
                                        <p className='justify mb-2'> Thank you for placing your trust in Krishnagar Public School. We look forward to walking this beautiful journey of learning and growth with you. </p>

                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />





                        <div className="d-flex justify-content-end align-items-end mb-0">
                            <div className='teamkps'>
                                <h6>Warm regards,</h6>
                                <p className='mb-0'>Mr. Amitava Guha 
                                </p>
                                <h5><b>Director</b> </h5>
                            </div>

                        </div>
                    </div>
                </div>
            </div>



        </div>
    )
}

export default MrAmitavaGuha